const zh = {
  nav: {
    home: "首页",
    about: "关于我们",
    destinations: "目的地",
    tours: "旅行团和套餐",
    gallery: "画廊",
    testimonials: "客户评价",
    blog: "博客",
    contact: "联系我们",
    experiences: "体验",
    vip: "VIP 商务",
    vipFull: "VIP 商务旅行",
    worldcup: "2030年世界杯",
    jewishHeritage: "犹太洁食旅行",
    menu: "菜单",
    chatWhatsApp: "在WhatsApp上聊天"
  },
  hero: {
    welcome: "欢迎来到摩洛哥。",
    welcomeHome: "欢迎回家。",
    subtitle: "私人豪华旅游，正宗的体验，",
    subtitleLine2: "以及摩洛哥各地的全套个性化服务 ——",
    subtitleGold: "由CEO亲自打理。",
    whatsappBtn: "现在在WhatsApp上与Ilan（CEO）聊天",
    badgeFast: "快速回复",
    badgePersonal: "个性化服务",
    badge247: "24/7 全天候可用",
    limitedAvail: "名额有限",
    personalizedOnly: "仅限个性化定制旅行"
  },
  strip: {
    privateTours: "私人旅行团",
    localExperts: "当地专家",
    bestHotels: "最佳酒店",
    luxuryTransport: "豪华交通",
    satisfaction: "100% 满意度"
  },
  cta: {
    whatsapp: "现在在WhatsApp上与Ilan（CEO）聊天",
    whatsappFloating: "在WhatsApp上聊天",
    whatsappInquiry: "你好，我对摩洛哥的高级旅行体验感兴趣。"
  },
  home: {
    vipBannerTitle: "VIP 摩洛哥旅行体验",
    vipBannerText: "为有品位的旅行者提供专属通道、私人司机和豪华住宿。",
    vipBannerBtn: "发现 VIP 服务",
    wcBadge: "🇲🇦 摩洛哥 2030年世界杯",
    wcTitle: "摩洛哥 2030",
    wcText: "结合足球、摩洛哥文化、VIP款待和豪华体验的独家世界杯旅游套餐。",
    wcBtn: "查看套餐",
    galleryTitle: "画廊",
    gallerySubtitle: "您未来的摩洛哥之旅一瞥",
    exploreDestination: "探索目的地",
    featuredToursTitle: "精选旅游团和套餐",
    featuredToursSubtitle: "精心策划的体验，为您打造完美的摩洛哥冒险之旅",
    viewAllTours: "查看所有旅游团",
    culinaryTitle: "我们的美食 - 世界第一",
    culinarySubtitle: "体验摩洛哥烹饪卓越 🍲",
    culinaryBtn: "探索美食体验",
    culinaryIntro: "在 Morocco Loves You，用餐不仅仅是进食。这是一场深入摩洛哥文化核心的旅程。我们提供真实、精心挑选的烹饪体验——从传统的家常菜到高端摩洛哥美食，所有食材都充满了爱，并选用最新鲜的当地食材。",
    videoTitle: "推荐",
    unityQuote: "Morocco Loves You 欢迎所有的文化、所有的信仰和所有的人民。",
    unityAlt: "Morocco Loves You 团结横幅",
    testimonialsTitle: "我们的VIP客人的评价",
    testimonialsSubtitle: "来自国际旅行者的真实评价",
    readMoreReviews: "阅读更多评价",
    viewAllTransport: "查看所有交通工具",
    transportTitle: "我们的贵宾 (VIP) 交通服务与司机",
    transportSubtitle: "纵横摩洛哥的奢华、舒适与安全 🌍",
    transportIntro: "在 Morocco Loves You，交通不仅仅是从一个地方移动到另一个地方。它是体验的一部分。我们提供现代化、干净、舒适且全空调的车辆遍布摩洛哥 — 配备专业的司机、热情的款待以及从第一刻起的贵宾服务。"
  },
  tours: {
    pageTitle: "旅行团和套餐",
    pageSubtitle: "从我们精心策划的摩洛哥旅游套餐中选择",
    sectionTitle: "我们的旅游套餐",
    sectionIntro: "从沙漠探险到沿海度假，我们为每位旅行者提供完美的套餐",
    howToBook: "如何预订",
    step1Title: "选择旅游团",
    step1Text: "浏览我们的套餐并选择最适合您的套餐",
    step2Title: "点击立即预订",
    step2Text: "点击您所选旅游团上的“立即预订”按钮",
    step3Title: "填写详细信息",
    step3Text: "提供您的旅行日期和个人信息",
    step4Title: "确认",
    step4Text: "通过电子邮件接收确认和行程详细信息",
    customTitle: "需要定制套餐吗？",
    customText: "联系我们，打造个性化的摩洛哥之旅",
    customBtn: "联系我们",
    days: "天数",
    highlights: "亮点:",
    bookNow: "立即预订",
    highlightsLabel: "亮点:",
    viewFullDetails: "查看完整详情",
    premiumMoroccoPackages: "摩洛哥高端旅行套餐",
    premiumMoroccoPackagesDesc: "为尊贵客人精心甄选的专属体验。",
    pkg1: {
      title: "欧洲/摩洛哥奢华周末之旅",
      duration: "3晚 / 4天",
      price: "€790",
      hl1: "包含直飞往返航班（伦敦/欧洲）",
      hl2: "4-5星级豪华酒店",
      hl3: "传统摩洛哥哈玛姆",
      hl4: "烹饪与艺术工作坊",
      hl5: "摩洛哥现场表演"
    },
    pkg2: {
      title: "摩洛哥奢华探索之旅",
      duration: "6晚 / 7天",
      price: "€1490",
      hl1: "套餐A",
      hl2: "阿特拉斯之旅",
      hl3: "马拉喀什 - 索维拉 - 梅尔祖卡 - 瓦尔扎扎特 - 马拉喀什",
      hl4: "大惊喜 ❤️",
      hl5: "套餐B"
    },
    pkg3: {
      title: "摩洛哥深度体验",
      duration: "10晚 / 11天",
      price: "€1990",
      hl1: "完整高端地接服务",
      hl2: "卡萨布兰卡、马拉喀什和菲斯",
      hl3: "阿加迪尔与撒哈拉沙漠惊喜",
      hl4: "参观瓦尔扎扎特和舍夫沙万",
      hl5: "特别现场音乐与表演"
    },
    pkg4: {
      title: "摩洛哥奢华体验",
      duration: "16晚 / 17天",
      price: "全包",
      hl1: "卡萨布兰卡 • 拉巴特 • 菲斯 • 丹吉尔 • 舍夫沙万",
      hl2: "伊夫兰 • 梅尔祖卡撒哈拉沙漠",
      hl3: "索维拉 • 乌里卡与阿特拉斯山脉 • 马拉喀什",
      hl4: "2晚豪华沙漠营地，含骆驼与吉普之旅",
      hl5: "梦幻日出与日落 • 星空下入眠"
    }
  },
  destinations: {
    pageTitle: "探索摩洛哥的目的地",
    pageSubtitle: "发现美丽的摩洛哥各地令人难以置信的景点",
    sectionTitle: "所有目的地",
    sectionIntro: "摩洛哥是一个拥有多样风景和丰富文化遗产的国家。探索我们精心挑选的目的地：",
    exploreNow: "立即探索",
    ctaTitle: "准备好计划您的旅行了吗？",
    ctaText: "浏览我们精心策划的旅游团和套餐，找到完美的摩洛哥体验",
    ctaBtn: "查看旅行团和套餐"
  },
  experiences: {
    pageTitle: "摩洛哥卓越的烹饪艺术",
    pageSubtitle: "发现我们的美食 —— 世界上最好的",
    bookViaWhatsApp: "通过WhatsApp预订"
  },
  vip: {
    pageTitle: "VIP 与商务旅行",
    pageSubtitle: "为首席执行官、投资者和挑剔的旅行者提供的专属服务",
    introTitle: "摩洛哥的无缝卓越",
    introText: "MoroccoLovesYou为商务旅行者、企业代表团和VIP客人提供无与伦比的服务标准。从落地到离开，我们精准处理每一个细节。",
    ctaTitle: "直接联系 CEO",
    ctaText: "如需紧急查询和高度专业化的要求，请直接与我们的创始人兼首席执行官Ilan Hatchuel对话。",
    ctaBtn: "现在联系 Ilan",
    luxuryTransport: "豪华交通",
    luxuryTransportDesc: "24/7提供VIP机场接送和双语私人司机，使用豪华车辆（梅赛德斯 S级、V级）。",
    premiumAccom: "高级住宿",
    premiumAccomDesc: "在五星级酒店、豪华摩洛哥传统庭院或私人别墅的独家预订。",
    businessConcierge: "商务礼宾服务",
    businessConciergeDesc: "提供全面的会议协助、私人用餐预订以及企业静修的专门行程。",
    securityPrivacy: "安全与隐私",
    securityPrivacyDesc: "为知名人士提供谨慎的服务、安全的环境和绝对的保密。",
    support247: "24/7 全天候支持",
    support247Desc: "直接与CEO联系，专门的团队随时准备协助您。",
    customItineraries: "定制行程",
    customItinerariesDesc: "量身定制的旅行计划，完美平衡您的商务义务与高品质的摩洛哥文化体验。"
  },
  worldcup: {
    pageTitle: "摩洛哥 2030年世界杯",
    pageSubtitle: "为最大足球赛事提供独家VIP套餐与旅行体验",
    limitedBadge: "名额有限",
    introTitle: "终极足球之旅",
    introText: "2030年，摩洛哥将联合举办FIFA世界杯。MoroccoLovesYou自豪地提供独家的全包豪华旅游套餐，专为追求最高舒适度与体验的球迷设计。",
    packagesTitle: "高级世界杯套餐",
    silverTitle: "白银套餐",
    silverSub: "基本体验",
    goldTitle: "黄金套餐",
    goldSub: "豪华体验",
    mostPopular: "最受欢迎",
    diamondTitle: "钻石 VIP",
    diamondSub: "终极体验",
    inquireWhatsApp: "通过WhatsApp咨询",
    ctaTitle: "在涨价前锁定名额",
    ctaText: "由于国际需求极高，我们强烈建议尽早预订您的VIP套餐。",
    ctaBtn: "立即联系我们",
    silverF1: "高级庭院 / 四星级酒店住宿",
    silverF2: "预先安排的比赛日后勤",
    silverF3: "城市导览游（主办城市）",
    silverF4: "24/7 专线支持",
    goldF1: "五星级酒店 / 豪华别墅住宿",
    goldF2: "私人机场与比赛接送",
    goldF3: "VIP沙漠营地度假（2天）",
    goldF4: "个人双语礼宾服务",
    diamondF1: "总统套房 / 私人宫殿",
    diamondF2: "24/7 私人司机与安保",
    diamondF3: "独家访问VIP活动与派对",
    diamondF4: "CEO直接处理与VVIP礼宾服务"
  },
  gallery: {
    pageTitle: "我们的画廊",
    pageSubtitle: "难忘摩洛哥之旅的视觉记忆",
    picturesTitle: "图片中的摩洛哥",
    picturesIntro: "探索我们令人惊叹的摩洛哥照片合集",
    videosTitle: "移动的摩洛哥",
    videosIntro: "通过我们精选的视频合集体验摩洛哥"
  },
  testimonials: {
    pageTitle: "客人评价",
    pageSubtitle: "阅读我们的旅行者关于他们摩洛哥体验的感受",
    sectionTitle: "我们快乐的旅行者",
    sectionIntro: "成千上万满意的客人与我们一起体验了摩洛哥的魔力",
    verifiedGuest: "已验证客人",
    ratingsTitle: "我们的评分",
    avgRating: "平均评分",
    verifiedReviews: "已验证的评价",
    fromReal: "来自真实旅行者",
    custSatisfaction: "客户满意度",
    wouldRecommend: "愿意推荐",
    shareTitle: "分享您的体验",
    shareText: "和我们度过了一次美妙的旅行？我们很乐意倾听！",
    shareBtn: "讲述您的故事"
  },
  blog: {
    pageTitle: "旅游博客",
    pageSubtitle: "您摩洛哥冒险的故事、提示和指南",
    sectionTitle: "最新旅游文章",
    sectionIntro: "阅读我们关于在摩洛哥旅行、当地文化和内部提示的最新文章",
    readMore: "阅读更多 →",
    by: "作者：",
    newsletterTitle: "订阅我们的通讯",
    newsletterText: "将最新的旅行提示和独家优惠发送到您的收件箱",
    newsletterPlaceholder: "输入您的电子邮件",
    subscribe: "订阅"
  },
  contact: {
    pageTitle: "联系我们",
    pageSubtitle: "与我们的团队联系，规划您的VIP摩洛哥冒险",
    getInTouch: "保持联系",
    getInTouchText: "我们随时为您提供帮助，并回答您的任何问题。",
    address: "地址",
    phone: "电话",
    email: "电子邮件",
    businessHours: "营业时间",
    businessHoursText: "星期一 - 星期五：上午 9:00 - 下午 6:00\n星期六：上午 10:00 - 下午 4:00\n星期日：休息",
    followUs: "关注我们",
    formTitle: "给我们发信息",
    successMessage: "✓ 谢谢！我们会尽快回复您。",
    fullName: "全名",
    emailAddress: "电子邮件地址",
    phoneNumber: "电话号码",
    subject: "主题",
    selectSubject: "选择一个主题",
    tourInquiry: "旅游咨询",
    bookingQuestion: "预订问题",
    customPackage: "定制套餐",
    feedback: "反馈意见",
    other: "其他",
    message: "信息",
    sendMessage: "发送信息",
    mapTitle: "在地图上找到我们",
    faqTitle: "常见问题",
    faq1Q: "访问摩洛哥的最佳时间是什么时候？",
    faq1A: "春季（4-5月）和秋季（9-10月）天气最好。",
    faq2Q: "我需要签证来访问摩洛哥吗？",
    faq2A: "签证要求取决于您的国籍。许多国家可免签入境长达90天。",
    faq3Q: "摩洛哥使用什么货币？",
    faq3A: "摩洛哥迪拉姆（MAD）是官方货币。",
    faq4Q: "摩洛哥讲什么语言？",
    faq4A: "阿拉伯语和柏柏尔语是官方语言。法语被广泛使用。",
    faq5Q: "摩洛哥对游客安全吗？",
    faq5A: "是的，摩洛哥总体上是安全的。我们的导游会确保您拥有安全的体验。",
    faq6Q: "我可以定制我的旅游套餐吗？",
    faq6A: "当然！我们提供符合您兴趣的定制套餐。"
  },
  about: {
    pageTitle: "关于 MoroccoLovesYou",
    pageSubtitle: "您探索摩洛哥魔力值得信赖的合作伙伴",
    storyTitle: "我们的故事",
    storyP1: "MoroccoLovesYou的创立有着简单的使命：帮助旅行者体验摩洛哥地道的美丽、文化和热情好客。",
    storyP2: "我们的创始人爱上了摩洛哥，并希望与世界分享这份热情。",
    missionTitle: "🎯 我们的使命",
    missionText: "提供非凡的旅行体验，展示摩洛哥丰富的文化遗产。",
    visionTitle: "🌟 我们的愿景",
    visionText: "成为以真实性和可靠性闻名的摩洛哥领先的旅游公司。",
    whyTitle: "为什么选择 MoroccoLovesYou？",
    expertTitle: "专业知识",
    expertText: "我们的团队对摩洛哥有广泛的了解。",
    localTitle: "当地连接",
    localText: "我们与正宗的当地导游合作。",
    valueTitle: "最佳价值",
    valueText: "极具竞争力的价格，且不牺牲质量。",
    safetyTitle: "安全与支持",
    safetyText: "包含 24/7 客户支持和全面旅行保险。",
    sustainTitle: "可持续旅游",
    sustainText: "我们支持当地社区并实行负责任的旅游。",
    bookingTitle: "轻松预订",
    bookingText: "提供灵活付款选项的简单在线预订流程。",
    teamTitle: "我们的团队",
    teamSubtitle: "认识 MoroccoLovesYou 背后充满激情的人们",
    happyTravelers: "满意的旅行者",
    yearsExp: "年经验",
    destinationsCount: "目的地",
    satisfactionRate: "满意率"
  },
  footer: {
    description: "与我们一起发现摩洛哥的魔力。体验难忘的冒险。",
    quickLinks: "快速链接",
    more: "更多",
    contactInfo: "联系信息",
    copyright: "© 2024 MoroccoLovesYou. 保留所有权利。"
  },
  starBanner: {
    ceoMessage: "CEO 的留言",
    watchVideo: "观看我的视频",
    readMessage: "& 阅读我的留言",
    getToKnow: "亲自认识",
    ilanPersonally: "Ilan"
  },
  tourMini: {
    days: "10 天",
    nights: "/ 9 晚",
    title: "摩洛哥\n高级旅游团",
    years: "2026 - 2027",
    departures: "每月出发",
    allIncluded: "全包\n包含全餐",
    recommendations: "推荐",
    recCount: "500+ 位快乐的旅行者"
  },
  cityDetail: {
    notFound: "未找到城市",
    backHome: "返回首页",
    discoverSubtitle: "探索美景与文化",
    planTrip: "计划我的旅行：",
    galleryOf: "画廊：",
    bookExperience: "预订此体验",
    requestItinerary: "请求完整行程",
    readyToVisit: "准备好访问了吗？",
    readyToVisitText: "让我们为您计划前往这个令人惊叹的目的地的完美之旅",
    planMyTrip: "计划我的旅行",
    talkExpert: "与专家交谈"
  },
  transportation: {
    pageTitle: "VIP 交通服务与司机",
    pageSubtitle: "纵横摩洛哥的奢华、舒适与安全",
    introTitle: "我们的 VIP 交通服务与司机",
    introP1: "在 Morocco Loves You，交通不仅仅是从一个地方移动到另一个地方。",
    introP2: "它是体验的一部分。",
    introP3: "我们提供现代化、干净、舒适且全空调的车辆遍布摩洛哥 — 配备专业的司机、热情的款待以及从第一刻起的贵宾服务。",
    introP4: "无论您是夫妻、家庭、商务代表团还是私人团体，我们都会确保您的旅程安全、轻松且令人难忘。",
    servicesTitle: "我们的交通服务包括",
    servicesList: [
      "现代化 VIP 巴士",
      "豪华小巴",
      "私人轿车",
      "用于沙漠探险的 4x4 吉普车",
      "VIP 豪华轿车",
      "机场接送服务",
      "专业多语种司机",
      "舒适的空调系统",
      "干净整洁的车辆",
      "部分车辆配备冰箱",
      "电视和娱乐系统",
      "旅途中的音乐陪伴",
      "安全平稳的驾驶",
      "遍布摩洛哥的 24/7 协助"
    ],
    driversTitle: "认识我们的司机",
    driversText1: "我们的司机是 Morocco Loves You 家族的一员。",
    driversText2: "专业、敬业、经验丰富，始终准备着以微笑提供帮助。",
    driversText3: "我们的许多司机精通多种语言，对摩洛哥有深入的了解 —— 帮助我们的客人在整个旅程中感到舒适、安全和紧密连接。",
    safetyTitle: "安全与舒适至上",
    safetyText1: "您的舒适和安全是我们的首要任务。",
    safetyText2: "所有车辆在每次行程前都会定期维护、清洁并精心准备。",
    safetyText3: "我们仅与值得信赖的专业司机和高质量的运输合作伙伴合作。",
    categories: {
      buses: "VIP 巴士",
      minibuses: "豪华小巴",
      cars: "私人轿车与 VIP 接送",
      jeeps: "4x4 吉普车与沙漠交通",
      meetDrivers: "认识我们的司机",
      videos: "交通体验视频"
    },
    videoGalleryTitle: "VIP 体验视频",
    ctaTitle: "准备好在舒适中探索摩洛哥了吗？",
    ctaSubtitle: "直接与创始人兼首席执行官 Allan 沟通",
    whatsapp: "WhatsApp: +972546338757",
    moroccoLine: "摩洛哥直拨热线: +212 6 63 63 05 79"
  },
  jewishHeritage: {
    pageTitle: "摩洛哥奢华犹太洁食之旅",
    pageSubtitle: "真实犹太遗产、100%犹太洁食、奢华款待与独特摩洛哥体验。",
    introTitle: "奢华犹太遗产体验",
    introHeading: "探索真实的犹太摩洛哥",
    introText: "通过优雅、真实、高端的旅行体验，探索犹太历史在摩洛哥的深厚根源。我们为全球犹太社群打造顺畅旅程，专注于传承、连接与绝对舒适。",
    introQuote: "“摩洛哥是宽容与共存之地，犹太遗产在这里被以爱与尊重守护。”",
    experiencesTitle: "我们的犹太洁食体验包括",
    experiencesList:     [
          "100%犹太洁食餐饮与餐厅",
          "可安排私人犹太洁食厨师",
          "传统摩洛哥犹太料理",
          "4与5星级豪华酒店",
          "私人VIP交通",
          "多语言专业导游",
          "犹太遗产与犹太会堂之旅"
    ],
    expFood: "100%犹太洁食",
    expRestaurant: "犹太洁食餐厅",
    expChef: "可安排私人犹太洁食厨师",
    expCuisine: "传统摩洛哥犹太料理",
    expHotels: "4与5星级豪华酒店",
    expDeluxeHotels: "可按需安排豪华酒店",
    expTransport: "私人VIP交通",
    expDrivers: "专业司机",
    expAC: "空调车辆",
    expWifi: "部分车辆配备WiFi、电视和冰箱",
    expGuides: "多语言专业导游",
    expStaff: "希伯来语 / 英语 / 法语 / 西班牙语 / 俄语 / 德语服务人员",
    expHeritage: "犹太遗产之旅",
    expSynagogues: "古老犹太会堂",
    expCemeteries: "犹太墓地",
    expMuseums: "犹太博物馆",
    expSpiritual: "精神与文化体验",
    expDesert: "撒哈拉沙漠体验",
    expHammam: "摩洛哥哈玛姆体验",
    expAttractions: "摩洛哥各地独特景点",
    expAssistance: "24/7协助",
    packagesTitle: "灵活的犹太洁食旅行套餐",
    packagesIntro: "我们会根据客人的需求、传统、旅行风格、日期和期待定制每一次旅程。",
    package4_5: "4-5 Days",
    package7_8: "7-8 Days",
    package10_11: "10-11 Days",
    package13_14: "13-14 Days",
    package21: "21天",
    packageTailor: "定制私人旅行",
    packagesQuote: "“我们会根据客人的需求、传统、旅行风格、日期和期待定制每一次旅程。”",
    safetyTitle: "舒适、专业且安全的旅行",
    safetyQuote: "“我们的旅行在摩洛哥全境都高度重视舒适、组织、服务质量和专业协调。”",
    b2bTitle: "B2B犹太旅行合作",
    b2bText: "我们与全球犹太社区、犹太会堂、拉比和犹太洁食旅行运营商合作，打造有意义的遗产之旅。",
    b2bPartnersList: "我们合作对象包括: 全球犹太社区、犹太会堂、拉比、犹太组织、犹太洁食旅行运营商和旅行社。",
    partnerBtn: "与我们合作",
    galleryTitle: "犹太洁食体验图库",
    videosTitle: "精选视频",
    ctaTitle: "准备开始您的旅程了吗？",
    msgAllan: "在 WhatsApp 联系 Allan",
    callMorocco: "致电摩洛哥: +212 6 63 63 05 79",
    ceoContact: "在 WhatsApp 直接联系 Allan Hatchuel",
    exploreBtn: "探索犹太洁食之旅"
  },
  aria: {
    openMenu: "打开菜单",
    closeMenu: "关闭菜单",
    whatsappSocial: "WhatsApp",
    kosherTravel: "摩洛哥犹太洁食旅行",
    logoAlt: "MoroccoLovesYou 标志",
    kingAlt: "摩洛哥国王",
    kosherOptionsAlt: "犹太洁食选项",
    jewishHeritageArchitecture: "犹太遗产建筑",
    kosherMoroccanTable: "摩洛哥犹太洁食餐桌",
    luxuryHospitality: "奢华款待",
    kosherExperience: "犹太洁食体验",
    jewishHeritageMorocco: "摩洛哥犹太遗产",
    kosherFoodMorocco: "摩洛哥犹太洁食",
    jewishHeritageExperience: "犹太遗产体验"
  }
};

export default zh;
